import React, { useEffect } from 'react';
import { Table } from 'antd';
import dayjs from 'dayjs';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import BasePagination from '../../pagination';
import LectureColumns from './lecture_columns';
import LectureDetailModal from './lecture_detail_modal';
import LectureDeleteModal from './lecture_delete_modal';

import { restApi } from '../../../apis';
//----------------------------------------------------------------------------------------------------
const LectureTable = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isBack = (location.state && location.state.isBack) || false;
  const [startNum, setStartNum] = React.useState(
    isBack ? location.state.startNum : 1
  );
  const [current, setCurrent] = React.useState(
    isBack ? location.state.current : -1
  );
  const [total, setTotal] = React.useState(isBack ? location.state.total : 0);
  const [sorts, setSorts] = React.useState(
    isBack
      ? location.state.sorts
      : {
          selected: 'lecture_title',
          name: 'asc', //desc
          email: 'asc', //desc
          createdAt: 'asc', //desc
          plan_name: 'asc', //desc
        }
  );
  const [dataSource, setDataSource] = React.useState([]);

  // const loading = props.loading;
  const setLoading = props.setLoading;
  const setGModal = props.setGModal;
  const centerId = props.centerId;
  const accountId = props.accountId;
  //----------------------------------------------------------------------------------------------------
  useEffect(() => {
    // 1페이지 정보 가져오기
    if (!isBack) {
      setCurrent(1);
    }
  }, []);

  useEffect(() => {
    // 로딩
    setLoading(true);
    //페이지가 변경되면 서버로 부터 데이터 가져오기
    (async (args) => {
      const params = {
        centerId: centerId,
        accountId: accountId,
        pageNum: current,
        orderBy: sorts.selected,
        sort: sorts[sorts.selected],
      };

      const response = await restApi.get(`/admin/lecture`, {
        params,
      });
      const payload = response && response.data && response.data.payload;

      if (payload) {
        setTotal(payload.totalCount || 1);
        setDataSource(payload.lectures || []);
      }
      setLoading(false);
    })();
  }, [current, sorts]);

  //----------------------------------------------------------------------------------------------------
  const OnCellClick = (args) => {
    setGModal((prev) => {
      return {
        ...prev,
        show: true,
        component: (
          <LectureDetailModal
            {...props}
            lectureId={args.id}
            setSorts={setSorts}
          />
        ),
      };
    });
  };

  const OnDeleteCellClick = (args) => {
    setGModal((prev) => {
      return {
        ...prev,
        show: true,
        component: (
          <LectureDeleteModal
            {...props}
            lectureId={args.id}
            setSorts={setSorts}
          />
        ),
      };
    });
  };

  //----------------------------------------------------------------------------------------------------
  return (
    <div style={{ width: '100%' }}>
      <Table
        columns={LectureColumns({
          ...props,
          sorts,
          setSorts,
          OnCellClick,
          OnDeleteCellClick,
        })}
        dataSource={dataSource}
        pagination={false}
        // loading={loading}
      />
      <BasePagination
        startNum={startNum}
        setStartNum={setStartNum}
        current={current}
        setCurrent={setCurrent}
        total={total}
        pageSize={10}
        {...props}
      />
    </div>
  );
};

export default LectureTable;
